import { testimonials } from '@/mocks/data';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            读者口碑
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            听听我们的读者和创作者怎么说——真实的声音，真诚的评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <h4 className="text-sm font-medium text-foreground-900">{t.name}</h4>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
                <div className="ml-auto flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                      <i className="ri-star-fill text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed italic">
                &ldquo;{t.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}